"use client";

import { useEffect } from "react";

export default function CapacitorInit() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem("fulkit_app") !== "1") return;

    const cap = window.Capacitor;
    if (!cap?.isNativePlatform?.()) return;

    console.log("[capacitor] native platform, plugins:", Object.keys(cap.Plugins || {}));

    // Listen for fulkit:// URL scheme opens (OAuth callback).
    // Converts fulkit://auth/callback?code=XXX → /auth/callback?code=XXX
    // so the existing callback page handles the exchange.
    // This is more reliable than a listener in signIn() because it survives
    // WebView freeze/thaw during the system browser OAuth flow.
    const handler = cap.Plugins.App?.addListener("appUrlOpen", ({ url }) => {
      console.log("[capacitor] appUrlOpen:", url);
      if (url && url.startsWith("fulkit://auth/callback")) {
        cap.Plugins.Browser?.close().catch(() => {});
        // Convert custom scheme to path — preserves query params (code, etc.)
        const params = url.split("?")[1] || "";
        const dest = "/auth/callback" + (params ? "?" + params : "");
        console.log("[capacitor] routing to:", dest);
        window.location.href = dest;
      }
    });

    return () => { handler?.remove?.(); };
  }, []);
  return null;
}
